"use client";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { classNames } from "../../utilities/props.js";
import SelectStartContent from "./SelectStartContent.js";
import SelectEndContent from "./SelectEndContent.js";
import s from "./Select.module.css";
const SelectNative = (props) => {
    const { startSlot, icon, size, inputAttributes, onFocus, onBlur, disabled, name, value, defaultValue, onChange, onClick, placeholder, id, children, } = props;
    const [empty, setEmpty] = React.useState(value === undefined ? !defaultValue : !value);
    const selectClassNames = classNames(s.input, placeholder && empty && s["input--placeholder"]);
    const handleChange = (event) => {
        const nextValue = event.target.value;
        // Uncontrolled placeholder
        if (value === undefined)
            setEmpty(!nextValue);
        if (!onChange)
            return;
        onChange({ name, value: nextValue, event });
    };
    // Controlled placeholder
    React.useEffect(() => {
        if (value === undefined)
            return;
        setEmpty(!value);
    }, [value]);
    return (_jsxs(_Fragment, { children: [_jsx(SelectStartContent, { startSlot: startSlot, icon: icon, size: size }), _jsxs("select", { ...inputAttributes, onFocus: onFocus || inputAttributes?.onFocus, onBlur: onBlur || inputAttributes?.onBlur, onClick: onClick || inputAttributes?.onClick, className: selectClassNames, disabled: disabled, name: name, value: value, defaultValue: defaultValue, onChange: handleChange, id: id, children: [placeholder && _jsx("option", { value: "", children: placeholder }), children] }), _jsx(SelectEndContent, { disabled: disabled, size: size })] }));
};
export default SelectNative;
